import { useCurrentuser } from '@uplift/contexts';
import React from 'react';
import { ModalFullPage, ModalFullPageContent } from '../../ModalFullPage';
import { useIsMobile } from '@uplift/hooks';
import { useAlert } from 'react-alert';
import { useQueryClient } from '@tanstack/react-query';
import { SubscribeGoogleCalendarForm } from './SubscribeGoogleCalendarForm';
import { NavigationBackButton, ProviderDialogNavigation } from '../../Layout';
import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()({
  modalContent: {
    padding: 0,
  }
});


export type SubscribeGoogleCalendarModalProps = {
  open: boolean;
  onClose: () => void;
};


export const SubscribeGoogleCalendarModal: React.FC<SubscribeGoogleCalendarModalProps> = (props) => {
  const { classes } = useStyles();
  const me = useCurrentuser();
  const queryClient = useQueryClient();
  const alert = useAlert();
  const isMobile = useIsMobile();

  return (
    <ModalFullPage open={props.open} onClose={props.onClose} transition>
      <ProviderDialogNavigation
        title="Connect Google Calendar"
        leftActions={
          <NavigationBackButton onClick={props.onClose}>back to schedule</NavigationBackButton>
        }
      />
      <ModalFullPageContent dividers={isMobile} className={classes.modalContent}>
        <SubscribeGoogleCalendarForm
          showFUETitle={false}
          nextButtonTitle="Save"
          enableNoOptionTip={false}
          onSuccess={(ics) => {
            props.onClose();
            if (ics) {
              alert.success(`${ics.title} successfully connected.`);
            }
            queryClient.invalidateQueries([ 'icsSubscription', me.id ]);
          }}
        />
      </ModalFullPageContent>
    </ModalFullPage>
  );
};
